import { cloneElement, ReactElement } from "react";

export const cloneElementWithCustomProps = (
  element: ReactElement,
  customProps: object,
) =>
  cloneElement(element, {
    ...element.props,
    ...customProps,
  });

export const getPopoutMenuId = (triggerId: string) => `${triggerId}-menu`;

export const getNavMenuButtonAriaProps = ({
  isOpen,
  id,
  ariaLabel,
}: {
  isOpen: boolean;
  id: string;
  ariaLabel?: string | undefined;
}) => {
  const ariaProps: IButtonAriaProps = {
    id,
    "aria-haspopup": true,
    "aria-expanded": isOpen,
  };

  if (ariaLabel) ariaProps["aria-label"] = `Toggle ${ariaLabel} Popup`;

  return ariaProps;
};

export interface IButtonAriaProps {
  id: string;
  "aria-haspopup": boolean;
  "aria-label"?: string;
  "aria-expanded": boolean;
}

export const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button:not([disabled])",
  "textarea:not([disabled])",
  'input[type="text"]:not([disabled])',
  'input[type="radio"]:not([disabled])',
  'input[type="checkbox"]:not([disabled])',
  "select:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
].join(", ");
